import * as z from 'zod';
import { ColorThemeEnum } from '@/enum/ColorThemeEnum';

const ParagraphZod = z.object({
  id: z.number(),
  text: z.string(),
  color: z.enum([ColorThemeEnum.WHITE, ColorThemeEnum.BLACK]),
  size: z.enum(['h1', 'h2', 'h3', 'h4', 'p1', 'p1-bold', 'p2', 'p2-bold', 'p3']),
});

export { ParagraphZod };
export type ParagraphType = z.infer<typeof ParagraphZod>;
